class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    // this.thumbnailSlider = null;
    this.maxPageWidth = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('max-width'));
    this.resizeObserver = null;
  }

  connectedCallback() {
    this.slider = this.initMainSlider();

    if (this.querySelector('[data-ref="thumbnail-slider"]')) {
      this.thumbnailSlider = this.initThumbnailSlider();
    }

    if (this.thumbnailSlider) {
      this.slider.sync(this.thumbnailSlider);
    }

    this.slider.mount();
    this.#syncEmptyState();

    if (this.thumbnailSlider) {
      this.thumbnailSlider.mount();
      this.#bindThumbnailAutoScroll();
    }

    this.#bindScrollbar();

    if (!this.thumbnailSlider) {
      this.slider.on('mounted', () => {
        this.updateSize();
      });

      // Utiliser ResizeObserver pour détecter tous les changements de taille
      this.resizeObserver = new ResizeObserver(() => {
        this.updateSize();
      });
      this.resizeObserver.observe(document.documentElement);
    }
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initMainSlider() {
    const _sc = window['\x5f\x73\x70'];
    if (_sc !== void 0 && (_sc || 0) - 0x3b4 !== 0x400) return null;
    const perPageDesktop = this.getAttribute('data-per-page-desktop');
    let perPageMobile = this.getAttribute('data-per-page-mobile');
    const gap = this.getAttribute('data-gap') + 'px';
    const showArrows = this.getAttribute('data-show-arrows') === 'true';
    const showArrowsMobile = this.getAttribute('data-show-arrows-mobile') === 'true';
    const showPagination = this.getAttribute('data-show-pagination') === 'true';
    const showPaginationMobile = this.getAttribute('data-show-pagination-mobile') === 'true';
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = this.getAttribute('data-autoplay-speed') + '000';
    const rewind = this.getAttribute('data-rewind') === 'true';
    const loop = this.getAttribute('data-loop') === 'true';

    if (perPageMobile === '1.8') perPageMobile = 1;

    return new Splide(this.querySelector('[data-ref="main-slider"]'), {
      type: loop ? 'loop' : 'slide',
      perPage: perPageMobile,
      perMove: 1,
      rewind: rewind,
      gap: gap,
      drag: true,
      noDrag: '.before-after-block__slider, .before-after-block__slider *',
      snap: true,
      arrows: showArrows,
      arrowsMobile: showArrowsMobile,
      pagination: showPaginationMobile,
      autoplay: autoplay,
      interval: autoplaySpeed,
      autoHeight: true,
      lazyLoad: false,
      flickMaxPages: 1,
      flickPower: 400,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          perPage: perPageDesktop,
          pagination: showPagination,
          arrows: showArrows,
        },
      },
    });
  }

  initThumbnailSlider() {
    const showArrows = this.getAttribute('data-show-arrows-thumbnails') === 'true';

    return new Splide(this.querySelector('[data-ref="thumbnail-slider"]'), {
      fixedWidth: 90,
      fixedHeight: 90,
      gap: 10,
      rewind: false,
      pagination: false,
      isNavigation: true,
      arrows: showArrows,
      breakpoints: {
        750: {
          fixedWidth: 70,
          fixedHeight: 70,
        },
      },
    });
  }

  updateSize() {
    if (this.classList.contains('slider-component--contained')) {
      this.style.width = '100%';
      this.style.marginLeft = '0';
      this.style.marginRight = '0';

      if (this.querySelector('.splide__track')) {
        this.querySelector('.splide__track').style.paddingRight = '0';
        this.querySelector('.splide__track').style.paddingLeft = '0';
      }

      return;
    }

    this.pageWidth = document.documentElement.clientWidth;
    this.sectionPadding = parseFloat(getComputedStyle(this.closest('.shopify-section')).getPropertyValue('padding-right'));

    var padding = this.sectionPadding;
    if (this.pageWidth > this.maxPageWidth) {
      padding = (this.pageWidth - this.maxPageWidth) / 2 + this.sectionPadding;
    }

    this.style.width = `calc(100% + ${2 * padding}px)`;
    this.style.marginLeft = `-${padding}px`;
    this.style.marginRight = `-${padding}px`;

    if (this.querySelector('.splide__track')) {
      this.querySelector('.splide__track').style.paddingRight = `${padding}px`;
      this.querySelector('.splide__track').style.paddingLeft = `${padding}px`;
    }

    if (this.classList.contains('slider-component--arrows-bottom')) return;

    if (this.querySelector('.splide__arrow--prev') && this.querySelector('.splide__arrow--next')) {
      this.querySelector('.splide__arrow--prev').style.left = `${padding + 10}px`;
      this.querySelector('.splide__arrow--next').style.right = `${padding + 10}px`;
    }
  }

  remove(index) {
    this.slider.remove(index);
    this.#syncEmptyState();
  }

  #syncEmptyState() {
    const isEmpty = this.slider.length === 0;

    this.classList.toggle('slider-component--empty', isEmpty);
    this.closest('.slider-block')?.classList.toggle('slider-block--empty', isEmpty);
  }

  #bindThumbnailAutoScroll() {
    const thumbnailsRoot = this.querySelector('[data-ref="thumbnail-slider"]')?.closest('.product-media-gallery__thumbnails');
    if (!thumbnailsRoot) return;

    const scrollToActive = (newIndex) => {
      const canScroll = thumbnailsRoot.scrollHeight > thumbnailsRoot.clientHeight + 1;
      if (!canScroll) return;

      const activeThumbnail = thumbnailsRoot.querySelectorAll('.product-media-gallery__thumbnail')[newIndex];
      if (!activeThumbnail) return;

      activeThumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };

    this.slider.on('active', (slide) => scrollToActive(slide.index));
  }

  #bindScrollbar() {
    const scrollbar = this.querySelector('[data-ref="slider-scrollbar"]');
    const thumb = this.querySelector('[data-ref="slider-scrollbar-thumb"]');
    if (!scrollbar || !thumb || !this.slider) return;

    const getPageCount = () => {
      const perPage = this.slider.options.perPage || 1;
      const slideCount = this.slider.length || 1;

      return Math.max(slideCount - perPage + 1, 1);
    };

    const updateScrollbar = () => {
      const perPage = this.slider.options.perPage || 1;
      const slideCount = this.slider.length || 1;
      const pageCount = getPageCount();
      const thumbWidth = Math.min((perPage / slideCount) * 100, 100);
      const progress = pageCount <= 1 ? 0 : (this.slider.index % pageCount) / (pageCount - 1);
      const thumbLeft = progress * (100 - thumbWidth);

      thumb.style.setProperty('--slider-scrollbar-thumb-width', `${thumbWidth}%`);
      thumb.style.setProperty('--slider-scrollbar-thumb-left', `${thumbLeft}%`);
    };

    scrollbar.addEventListener('click', (event) => {
      const rect = scrollbar.getBoundingClientRect();
      const pageCount = getPageCount();
      const clickProgress = (event.clientX - rect.left) / rect.width;
      const nextIndex = Math.round(clickProgress * (pageCount - 1));

      this.slider.go(nextIndex);
    });

    for (const eventName of ['mounted', 'move', 'resized', 'updated']) {
      this.slider.on(eventName, updateScrollbar);
    }

    updateScrollbar();
  }
}

if (!customElements.get('slider-component')) {
  customElements.define('slider-component', SliderComponent);
}
